import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    TablePagination,
    darken,
    lighten,
    // InputAdornment,
} from "@mui/material";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useDispatch, useSelector } from "react-redux";
import {
    applyDevicesCatFilter,
    applyDevicesFilter,
} from "../../../Actions/Devices";
// import SearchIcon from "@mui/icons-material/Search";
import CustomTextField from "../../../Components/common/TextField";
export default function GeofenceTable(props) {
    const dispatch = useDispatch();
    const updatedGeofences = useSelector((state) => state.geoFence);
    const allInsideGeofences = useSelector((state) => state.insideGeofence);
    const devicesForCategories = useSelector((state) => state.devices3);
    const categoriesFromRedux = useSelector((state) => state.categories);
    const themecolors=useSelector((state)=>state.themeColors)

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const allGeofences = useMemo(() => {
        return (
            updatedGeofences?.filter(
                (item) => item?.attributes?.type?.toLowerCase() !== "kmlfile"
            ) || []
        );
    }, [updatedGeofences]);



    useEffect(() => {
        let newList = ["allGeoIds"];
        dispatch(applyDevicesCatFilter([]));
        dispatch(applyDevicesFilter(newList, allGeofences));
    }, [allInsideGeofences, allGeofences]);

    const handleSelectedCell = useCallback(
        (value) => {
            props.hideGeofencesTable(value);
            dispatch(applyDevicesCatFilter([]));
            dispatch(applyDevicesFilter(["geoIds"], value.geoId));
        },
        [dispatch, props]
    );

// const categories = useMemo(() => {
//   const cats =
//     devicesForCategories?.map((d) => d.category).filter(Boolean) || [];
//   const unique = [...new Set(cats)];

//   return unique;
// }, [devicesForCategories]);

  const categories = useMemo(() => {
    const list = [...categoriesFromRedux];
    const hasDefault = list?.some(
      (item) =>
        typeof item === "object"
          ? item?.dtype === "N/S"
          : item === "N/S"
    );
    if (!hasDefault) {
      list.push({
        id: "N/S",
        label: "N/S",
        dtype: "N/S",
        contractNumber: "",
        parentId: null,
      });
    }
    return list;
  }, [categoriesFromRedux]);

// const geoCategoryCounts = useMemo(() => {
//   const countsByGeo = {};
//   allGeofences.forEach((geo) => {
//     const inside = allInsideGeofences[geo.id] || [];
//     const counts = {};

//     inside.forEach((deviceId) => {
//       const device = devicesForCategories?.find((d) => d.id === deviceId);
//       if (device) {
//         const category = device.category;

//         if (category && categories.includes(category)) {
//           counts[category] = (counts[category] || 0) + 1;
//         } else {
//           counts["default"] = (counts["default"] || 0) + 1;
//         }
//       }
//     });

//     countsByGeo[geo.id] = counts;
//   });

//   return countsByGeo;
// }, [allGeofences, allInsideGeofences, devicesForCategories, categories]);

const geoCategoryCounts = useMemo(() => {
    const countsByGeo = {};

    allGeofences.forEach((geo) => {
      const inside = allInsideGeofences[geo.id] || [];
      const counts = {};

      inside.forEach((deviceId) => {
        const device = devicesForCategories?.find((d) => d.id === deviceId);
        if (device) {
          const label =
            device.devicetypeLabel;
          const categoryObj = categories?.find(
            (c) =>
              c.label?.toLowerCase() === label?.toLowerCase() ||
              c.dtype?.toLowerCase() === label?.toLowerCase()
          );

          const finalLabel = categoryObj?.label;
          counts[finalLabel] = (counts[finalLabel] || 0) + 1;
        }
      });

      countsByGeo[geo.id] = counts;
    });

    return countsByGeo;
  }, [allGeofences, allInsideGeofences, devicesForCategories, categories]);

    const sortGeoData = (data, geoIds) =>
        [...data].sort(
            (b, a) => (geoIds[a.id]?.length || 0) - (geoIds[b.id]?.length || 0)
        );

    const sortedData = useMemo(
        () => sortGeoData(allGeofences, allInsideGeofences),
        [allGeofences, allInsideGeofences]
    );


const deviceMap = useMemo(() => {
  const map = {};
  devicesForCategories.forEach((d) => (map[d.id] = d.uniqueId?.toLowerCase() || ""));
  return map;
}, [devicesForCategories]);

const filteredData = useMemo(() => {
  if (!search) return sortedData;
  const lowerSearch = search.toLowerCase();

  return sortedData.filter((geo) => {
    const geoNameMatch = geo.name.toLowerCase().includes(lowerSearch);
    const inside = allInsideGeofences[geo.id] || [];

    const deviceMatch = inside.some((id) => deviceMap[id]?.includes(lowerSearch));
    return geoNameMatch || deviceMatch;
  });
}, [search, sortedData, allInsideGeofences, deviceMap]);


    // const paginatedData = useMemo(() => {
    //     return filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    // }, [filteredData]);



const categoryTotals = useMemo(() => {
  const totals = {};

  filteredData.forEach((geo) => {
    const geoCounts = geoCategoryCounts[geo.id] || {};
    Object.entries(geoCounts).forEach(([label, count]) => {
      totals[label] = (totals[label] || 0) + count;
    });
  });

  return totals;
}, [filteredData, geoCategoryCounts]);



const sortedCategories = useMemo(() => {
  return [...categories].sort((a, b) => {
    const totalA = categoryTotals[a.label] || 0;
    const totalB = categoryTotals[b.label] || 0;
    return totalB - totalA;
  });
}, [categories, categoryTotals]);

   const paginatedCategories = useMemo(() => {
  return sortedCategories.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
}, [sortedCategories, page, rowsPerPage]);

    return (
        <Box sx={{ height: "100vh", p: 0 }}>
            <Paper
                elevation={3}
                sx={{
                    p: 2,
                    mb: 2,
                    bgcolor:themecolors?.backgroundColor|| "#045266",
                    color:themecolors?.textColor|| "white",
                    borderRadius: 1,
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                    gap={2}
                >
                    <Box>
                        <Typography variant="body2">Total Geofence</Typography>
                        <Typography variant="h4" fontWeight="bold">
                            {allGeofences?.length}
                        </Typography>
                    </Box>
                    <Box>

                        <CustomTextField
                            label={"Search"}
                            type='search'
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(0);
                            }}
                        />
                    </Box>
                </Box>
            </Paper>
            <TableContainer
                component={Paper}
               sx={{
    bgcolor: themecolors?.menuActiveBackground || "#0a83a1",
    color: "white",
    maxHeight: "70%",
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: themecolors?.menuActiveBackground || "#0a83a1",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: themecolors?.themeDarkColor || "#045266",
      borderRadius: "8px",
      border: `2px solid ${
        themecolors?.menuActiveBackground || "#0a83a1"
      }`,
      transition: "background-color 0.2s ease",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: darken(themecolors?.themeDarkColor || "#045266", 0.3),
    },
    
    scrollbarWidth: "auto",
    scrollbarColor: `${
      themecolors?.themeDarkColor || "#045266"
    } ${themecolors?.menuActiveBackground || "#0a83a1"}`,

    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: darken(themecolors?.themeDarkColor || "#045266", 0.3),
    },
  }}
            >
                <Table stickyHeader sx={{ minWidth: 700 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                sx={{
                                    position: "sticky",
                                    top: 0,
                                    left: 0,
                                    zIndex: 3,
                                    bgcolor:themecolors?.backgroundColor|| "#045266",
                                    color:themecolors?.textColor|| "white",
                                    fontWeight: "bold",
                                    minWidth: 150,
                                    wordBreak: "break-word",
                                    borderBottom: "1px solid #4f8d9c",
                                }}
                            >
                               Vehicle Types
                            </TableCell>
                            <TableCell
                                sx={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    bgcolor:themecolors?.menuActiveBackground|| "#0a83a1",
                                    width: 20,
                                    border: "0px",
                                }}
                            />
                            {filteredData.map((geo, i) => (
                                <TableCell
                                    key={i}
                                    sx={{
                                        position: "sticky",
                                        top: 0,
                                        bgcolor:themecolors?.backgroundColor|| "#045266",
                                        color:themecolors?.textColor|| "white",
                                        fontWeight: "bold",
                                        minWidth: 120,
                                        textAlign: "center",
                                        borderBottom: "none",
                                    }}
                                         title={geo.name}
                                >
                                    {geo.name} ({Object.values(geoCategoryCounts[geo.id] || {}).reduce((sum, val) => sum + val, 0)})

                                    {/* {cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase()} */}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {paginatedCategories.map((cat, idx) => {
                            // const totalCount = Object.values(geoCategoryCounts[geo.id] || {}).reduce(
                            //     (sum, val) => sum + val,
                            //     0
                            // );
                            return (
                                <TableRow key={cat.id}>
                                    <TableCell
                                        sx={{
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 2,
                                            bgcolor:themecolors?.backgroundColor|| "#045266",
                                            color:themecolors?.textColor|| "white",
                                            width: 180,
                                            maxWidth: 200,
                                            borderBottom: "1px solid #4f8d9c",
                                            p: 1,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                            // title={`${cat.name} (${totalCount})`}
                                        >
                                           {cat.label === "N/S" ? "Default" : cat.label}
{" "}
({categoryTotals[cat.label] || 0})
                                        </Box>
                                    </TableCell>

                                    <TableCell
                                        sx={{ bgcolor:themecolors?.menuActiveBackground|| "#0a83a1", width: 20, border: "0px" }}
                                    />
                                    {console.error("them",themecolors)}
                                    {filteredData.map((geo, i) => (
                                        <TableCell
                                            key={geo.id + "_" + cat.label||i}
                                            sx={{
                                                color:themecolors?.textColor|| "white",
                                                bgcolor: idx % 2 === 0 ? lighten(themecolors?.menuActiveBackground,0.1) : darken(themecolors?.menuActiveBackground,0.1),
                                                textAlign: "center",
                                                minWidth: 120,
                                                border: `1px solid ${darken(themecolors?.backgroundColor,0.2)}` ,
                                                cursor: "pointer",
                                                "&:hover": { bgcolor:lighten(themecolors?.menuActiveBackground, 0.3)|| "#0aa0c0" },
                                            }}
                                            onClick={() =>
                                                handleSelectedCell({
                                                    geoId: geo.id,
                                                    category: cat.label,
                                                    geofenceName: geo.name,
                                                })
                                            }
                                        >
                                            {geoCategoryCounts[geo.id]?.[cat.label] || 0}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

    <TablePagination
  component="div"
  count={categories?.length}
  page={page}
  onPageChange={(e, newPage) => setPage(newPage)}
  rowsPerPage={rowsPerPage}
  onRowsPerPageChange={(e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  }}
//   sx={{
//     color: "white",
//     "& .MuiSvgIcon-root": { color: "white" },
//     "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
//       color: "white",
//     },
//     "& .MuiInputBase-root": {
//       color: "white",
//       "& svg": { color: "white" },
//     },
//   }}
/>

        </Box>
    );
}
